import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import {listFilter} from 'utils/utils'

const Field = styled(TextField)`
	width: auto;
	padding: 10px;
	position: sticky;
	top: 0;
	background: #FFFFFF;
	z-index: 1;
	display: flex;
`

class Selector extends React.Component {
    constructor(props) {
        super(props)
        this.options = []

        this.state = {
            anchorEl: null,
            search: ''
        }
    }

    handleClick = event => {
        this.props.data.forEach(item => this.options.push({...item}))
        this.setState({ anchorEl: event.currentTarget })
    }

    handleClose = () => {
        this.options = []
        this.setState({ anchorEl: null, search: '' })
    }

    handleSearch = (e) => {
        this.options = listFilter(this.props.data, e.currentTarget.value, ['name'])
        this.setState({ search: e.currentTarget.value })
    }

    handleSelect = (data) => {
        this.props.handleSelect(data)
        this.handleClose()
    }

    render() {
        const {intl} = this.props

        return (
            <React.Fragment>
                <Button variant="contained" disabled={this.props.disabled}
                    onClick={this.handleClick}
                    style={{background: '#4cae4c', color: '#FFF'}}
                >
                    {intl.formatMessage({id: this.props.text})}
                </Button>
                <Menu
                    anchorEl={this.state.anchorEl}
                    open={Boolean(this.state.anchorEl) && !this.props.disabled}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
					PaperProps={{
						sx: {
							maxHeight: '250px'
						}
					}}
                    MenuListProps={{
						sx: {
							paddingTop: 0
						}
					}}
                >
                    <Field variant="standard"
                        onChange={this.handleSearch}
                        value={this.state.search}
                        onKeyDown={(e) => e.stopPropagation()}

                    />
                    {this.options.map((item, index) =>
                        <MenuItem key={index} onClick={() => this.handleSelect(item)}>
                            <Typography variant='inherit' noWrap>
                                {item.name}
                            </Typography>
                        </MenuItem>
                    )}
                </Menu>
            </React.Fragment>
        )
    }
}

export default injectIntl(Selector)
